<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M15.22 8.60949V15.2195C15.22 15.3656 15.162 15.5057 15.0587 15.609C14.9554 15.7123 14.8153 15.7703 14.6692 15.7703H10.8133C10.6672 15.7703 10.5271 15.7123 10.4238 15.609C10.3205 15.5057 10.2625 15.3656 10.2625 15.2195V11.6391C10.2625 11.566 10.2335 11.496 10.1818 11.4443C10.1302 11.3927 10.0601 11.3637 9.98708 11.3637H7.23292C7.15987 11.3637 7.08982 11.3927 7.03817 11.4443C6.98652 11.496 6.9575 11.566 6.9575 11.6391V15.2195C6.9575 15.3656 6.89947 15.5057 6.79616 15.609C6.69286 15.7123 6.55276 15.7703 6.40667 15.7703H2.55083C2.40474 15.7703 2.26464 15.7123 2.16134 15.609C2.05803 15.5057 2 15.3656 2 15.2195V8.60949C2.00014 8.31736 2.11629 8.03725 2.32293 7.83075L7.83126 2.32242C8.03784 2.11597 8.31795 2 8.61 2C8.90206 2 9.18216 2.11597 9.38874 2.32242L14.8971 7.83075C15.1037 8.03725 15.2199 8.31736 15.22 8.60949Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'CaseProfileIconFilled18'
};
</script>

<style scoped>

</style>